import { Dialog } from '@cmsgov/ds-medicare-gov';
import * as PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { helpDrawerImpression } from '../analytics';
import '../css/dialog.css';
import translate from '../functions/translate';
import medicareCard from '../images/medicare-card-partab-new.png';
import X from '../images/x.svg';
import Button from './button';
import Div from './div';
import H2 from './h2';
import TranslatedSpan from './translated.span';

const MedicareStartDateDialog = props => {

   const headerText = translate('Where to find your Part A and Part B start date');
   useEffect(() => {
      if (props.isOpen) {
         helpDrawerImpression(headerText);
      }
   }, [props.isOpen, headerText]);
   
   if (!props.isOpen)
      return null;
   return <>
      <Dialog
         className={'drawer-dialog'}
         getApplicationNode={() => document.getElementById('App')}
         headerClassName={'drawer-dialog-header'}
         onExit={props.onExit}
         underlayClickExits={true}
      >
         <H2>
            <div style={{
               cursor: 'pointer',
               float: 'right',
            }}>
               <Button
                  aria-label={translate('Close')}
                  color={'white'}
                  displayAs={'link'}
                  onClick={props.onExit}
               >
                  <img
                     alt={translate('Close')}
                     src={X}
                     style={{
                        position: 'relative',
                        bottom: 15,
                        left: 15,
                     }}
                  />
               </Button>
            </div>
            <div>
               <TranslatedSpan
                  english={'Where to find your Part A and Part B start date'}
                  replacements={{letter: props.part}}
               />
            </div>
         </H2>
         <Div paddingyMD={1} paddingyXL={2}>
            <TranslatedSpan english={'Check your red, white and blue Medicare card. If you need help registering, contact us at 1-800-633-4227. TTY: 1-877-486-2048.'}/>
         </Div>
         <Div
            paddingyMD={1} paddingyXL={2}
            style={{textAlign: 'center'}}
         >
            <img
               alt={translate('Medicare card example')}
               src={medicareCard}
               style={{
                  maxWidth: 400,
                  width: '100%',
               }}
            />
         </Div>
      </Dialog>
   </>
}

MedicareStartDateDialog.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onExit: PropTypes.func.isRequired,
   part: PropTypes.oneOf(['A', 'B']).isRequired,
};

export default MedicareStartDateDialog;